import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { RackTrayRefDto, CabinetShelfRefDto } from '@cradua/data';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-racktrayref',
  templateUrl: './racktrayref.component.html',
  styleUrls: ['./racktrayref.component.scss']
})
export class RackTrayRefComponent implements OnChanges {

  @Input() racktrayrefs: RackTrayRefDto[];
  @Input() cabinetshelfrefs: CabinetShelfRefDto[];
  racktrayrefForm: FormGroup;
  racktrayrefFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<RackTrayRefDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredRackTrayRef: Array<any> = [];
  status: boolean;
  selectedRackTrayRefId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createRackTrayRefForm();
    console.log('onChanges', this.racktrayrefs);
  }

  createRackTrayRefForm() {
    this.racktrayrefFormArray = this.fb.group({
      RackTrayRefs: this.fb.array([]),
    });
    this.racktrayrefForm = this.fb.group({
      RackTrayRefNo: ['', Validators.required],
      CabinetShelfRefId: this.selectedRackTrayRefId,
      id: null,
    });
  }

  // method to display cabinetshelfrefs
  setRackTrayRef() {
    const control = this.racktrayrefFormArray.controls
      .RackTrayRefs as FormArray;
    this.filteredRackTrayRef.forEach((e) => {
      console.log('foreach value ', e);
      control.push(
        this.fb.group({
          RackTrayRefNo: e.RackTrayRefNo,
          CabinetShelfRefId: e.CabinetShelfRefId,
          id: e.id,
        })
      );
    });
  }

  // method to add CabinetShelfRef
  addRackTrayRef(racktrayref: RackTrayRefDto) {
    console.log('racktrayref');
    const control = this.racktrayrefFormArray.controls
      .RackTrayRefs as FormArray;
    control.insert(
      0,
      this.fb.group({
        RackTrayRefNo: racktrayref.RackTrayRefNo,
        CabinetShelfRefId: this.selectedRackTrayRefId,
      })
    );
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.racktrayrefFormArray.controls
      .RackTrayRefs as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter racktrayref
  selectCabinetShelfRef(event: string) {
    this.filteredRackTrayRef = this.racktrayrefs.filter(
      (s) => s.CabinetShelfRefId === event
    );
    this.selectedRackTrayRefId = event;
    const control = this.racktrayrefFormArray.controls
      .RackTrayRefs as FormArray;

    if (this.filteredRackTrayRef.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setRackTrayRef();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete cabinetshelfref from arrary list
  deleteRackTrayRef(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.racktrayrefFormArray.controls
          .RackTrayRefs as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.racktrayrefs.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.racktrayrefs[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: RackTrayRefDto) {
    if (this.racktrayrefForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.racktrayrefFormArray
        .get('RackTrayRefs')
        ['controls'][this.selectedIndex].patchValue({
          RackTrayRefNo: formValue.RackTrayRefNo,
        });
    } else {
      this.addRackTrayRef(formValue);
    }
    this.selectedIndex = null;
    this.racktrayrefForm.reset();
  }

  onEdit(index, value: RackTrayRefDto) {
    this.selectedIndex = index;
    this.racktrayrefForm.patchValue({ RackTrayRefNo: value.RackTrayRefNo });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.racktrayrefForm.reset();
  }

  onSubmit(formValue: any) {
    formValue.type = 'racktrayref';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('racktrayref');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }

}
